"use client";

import Link from "next/link";
const styles = new Proxy({"GetInTouch":"GetInTouch-2c75d","GetInTouchInner":"GetInTouchInner-2c75d","cover":"cover-2c75d"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
import Section from "../Section";
const forensicStyles = new Proxy({"ForensicAnalysis":"ForensicAnalysis-011dd","videoContainer":"videoContainer-011dd","intro":"intro-011dd","GetInTouch":"GetInTouch-011dd","GetInTouchInner":"GetInTouchInner-011dd","Utilize":"Utilize-011dd","Box":"Box-011dd","Center":"Center-011dd","CaseStudy":"CaseStudy-011dd","CaseStudyContent":"CaseStudyContent-011dd","ImgBox":"ImgBox-011dd","CaseStudyForm":"CaseStudyForm-011dd","SubmitButton":"SubmitButton-011dd","Notice":"Notice-011dd","TurnIntoEvidence":"TurnIntoEvidence-011dd","TurnIntoEvidenceContent":"TurnIntoEvidenceContent-011dd","TurnIntoEvidenceContentReverse":"TurnIntoEvidenceContentReverse-011dd"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

interface GetInTouchProps {
  block: {
    title?: string;
    subheading?: string;
    ctaLabel?: string;
    ctaHref?: string;
    bulletPoints?: { bulletPoint: string }[];
    isTwoRows?: boolean;
  };
}

const DEFAULT_BULLET_POINTS = [
  { bulletPoint: "License our AI models to analyze your movement data" },
  { bulletPoint: "Extract more value from your movement sensor" },
  { bulletPoint: "Outsource your ML project to save time and money" },
];

const GetInTouch = ({ block }: GetInTouchProps) => {
  const { title, ctaLabel, ctaHref, bulletPoints, subheading, isTwoRows } =
    block;
  const usedBulletPoints = bulletPoints?.length
    ? bulletPoints
    : DEFAULT_BULLET_POINTS;

  const middle = Math.ceil(usedBulletPoints.length / 2);
  const usedStyles = isTwoRows ? forensicStyles : styles;
  return (
    <div className={usedStyles.ForensicAnalysis}>
      <Section className={`py-3 ${usedStyles.cover}`}>
        <div className="row my-5 px-0 px-md-2">
          <div className="col-12 px-0 px-md-2">
            <div className={usedStyles.GetInTouch}>
              <div className={usedStyles.GetInTouchInner}>
                <h3 className={`${isTwoRows ? "text-center" : ""}`}>
                  {title ||
                    "Tap into our world-leading expertise, become our partner"}
                </h3>
                {subheading && isTwoRows && (
                  <h4 className="text-center">{subheading}</h4>
                )}
                {!isTwoRows && (
                  <Link
                    href={ctaHref || "#ContactForm"}
                    className="ButtonPrimary"
                  >
                    {ctaLabel || "Get in touch"}
                  </Link>
                )}
              </div>
              <div className={`row ${usedStyles.GetInTouchInner}`}>
                {!isTwoRows && (
                  <ul>
                    {usedBulletPoints.map((point, index) => (
                      <li key={index}>{point.bulletPoint}</li>
                    ))}
                  </ul>
                )}
                {isTwoRows && (
                  <>
                    <ul className="col-lg-6 col-12">
                      {usedBulletPoints.slice(0, middle).map((point, index) => (
                        <li key={index}>{point.bulletPoint}</li>
                      ))}
                    </ul>
                    <ul className="col-lg-6 col-12">
                      {usedBulletPoints.slice(middle).map((point, index) => (
                        <li key={index}>{point.bulletPoint}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default GetInTouch;
